export default __webpack_public_path__ + "static/media/thanksgiving.0d06af68.png";